import { apiClient } from './apiClient';

/*
    GET obtiene las definiciones de las columnas de la tabla
 */
export const fetchColumnDefinitions = async () => {
    try {
        const response = await apiClient.get('/maestra/describe');
        return response.data;
    } catch (error) {
        throw error;
    }
};

/*
    GET obtiene los datos de la tabla
 */
export const fetchFilteredData = async () => {
    try {
        const response = await apiClient.get('/maestra/listar');
        return response.data.filter(item => item.status !== "Ready to Claim");
    } catch (error) {
        throw error;
    }
};
